/* import __COLOCATED_TEMPLATE__ from './external-conversation-avatar.hbs'; */
/* RESPONSIBLE TEAM: team-standalone */

import Component from '@glimmer/component';
import { type InterfaceIconName } from '@intercom/pulse/lib/interface-icons';
import type Conversation from 'embercom/objects/inbox/conversation';
import type ConversationSummary from 'embercom/objects/inbox/conversation-summary';
import type ConversationTableEntry from 'embercom/objects/inbox/conversation-table-entry';

interface Signature {
  Args: {
    conversation: Conversation | ConversationSummary | ConversationTableEntry;
  };
}

export default class ExternalConversationAvatar extends Component<Signature> {
  get colorClasses() {
    if (this.args.conversation.isZendeskConversation) {
      return 'bg-success-fill-emphasis text-on-success';
    }

    if (this.args.conversation.isSalesforceConversation) {
      return 'bg-beta-fill-emphasis text-on-beta';
    }

    if (this.args.conversation.isHubspotConversation) {
      return 'bg-accent-fill text-on-accent';
    }

    if (this.args.conversation.isFreshdeskConversation) {
      return 'bg-success-fill-emphasis text-on-success';
    }

    return 'bg-neutral-container-emphasis text-on-neutral';
  }

  get icon(): InterfaceIconName {
    if (this.args.conversation.isZendeskConversation) {
      return 'zendesk';
    }

    if (this.args.conversation.isSalesforceConversation) {
      return 'salesforce';
    }

    if (this.args.conversation.isHubspotConversation) {
      return 'hubspot';
    }

    return 'circle-filled';
  }
}

declare module '@glint/environment-ember-loose/registry' {
  export default interface Registry {
    'Inbox2::Common::ExternalConversationAvatar': typeof ExternalConversationAvatar;
    'inbox2/common/external-conversation-avatar': typeof ExternalConversationAvatar;
  }
}
